import React from 'react'
import muiThemeable from 'material-ui/styles/muiThemeable'
import { TextField as MUITextField } from 'material-ui'

const TextField = ({
  muiTheme,
  inputStyle,
  underlineStyle,
  style,
  hintStyle,
  ...other
}) => (
  <MUITextField
    underlineStyle={{ bottom: 0, ...underlineStyle }}
    style={{
      backgroundColor: muiTheme.custom.colors.textInputBackgroundColor,
      marginTop: 8,
      marginBottom: 8,
      ...style,
    }}
    inputStyle={{
      marginLeft: 5,
      marginRight: 5,
      ...inputStyle,
    }}
    hintStyle={{
      padding: 5,
      ...hintStyle,
    }}
    {...other}
  />
)

export default muiThemeable()(TextField)



// WEBPACK FOOTER //
// ./src/components/TextField.js